/**
 * en-GB messages added by Phase 4 task S51 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s51EnGB = {
    'dataProtection.page': 'Data protection',
    'dp.label.selected': 'Selected records',
    'dp.error.provider_not_ready': 'Some parts of CloudSign cannot yet find or remove personal data. The erasure was not run.',
    'dp.error.erase_failed': 'The erasure could not be completed. Nothing further was removed; ask support for help.',
    'dp.error.export_failed': 'The export could not be completed.',
    'dp.error.legal_hold': 'Some records are under a legal hold and were kept. The rest were erased.',
    'dp.error.hold_empty': 'Name at least one visit or member for the hold.',
    'dp.error.hold_released': 'This legal hold has already been released.',
    'dp.error.export_expired': 'This export is no longer available.',
    'dp.export.title': 'Personal data export',
    'dp.export.generated': 'Generated',
    'dp.export.reason': 'Reason',
    'dp.export.section_empty': 'Nothing held.',
    'dp.export.not_covered': 'Not covered yet',
    'dp.retention.none': 'Kept until deleted by hand.',
};
//# sourceMappingURL=s51.js.map